export default () => ({
    loading:false,
    catalogs:[],
    total:0,
    loaded: false,
})